import $ from 'jquery';

(() => {
  $(document).ready(function() {
    $('.faqs__filter-link').on('click', function(e) {
      e.preventDefault();
      let currentFAQContainer = $(this).parents('.faqs');
      let currentFilterLinks = currentFAQContainer.find('.faqs__filter-link');
      let currentListItems = currentFAQContainer.find('.faqs__list-item');
      let category = $(this).attr('data-filter-by');
      let emptyMsg = currentFAQContainer.find('.empty-msg');

      // Remove all active classes
      currentFilterLinks.removeClass('active');
      // Add "active" class to current item
      $(this).addClass('active');
      // Fade out all items
      currentListItems.fadeOut('fast');
      emptyMsg.fadeOut('fast');
      // Fade in items that have the same category data attribute
      if (category !== 'all') {
        // If not the "all" category, filter just items that match
        let results = currentFAQContainer.find(
          '.faqs__list-item[data-category*=\'' + [category] + '\']'
        );
        if (results.length > 0) {
          results.fadeIn('fast');
        } else {
          emptyMsg.fadeIn('fast');
        }
      } else {
        // Show all items
        currentListItems.fadeIn('fast');
      }
    });
  });
})();



// WEBPACK FOOTER //
// ./resources/views/library/patterns/faqs/faqs.js